import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { FetchAffiliateDetailsResponse } from '@/modules/Affiliate/types/api/response'

export const QUERY_KEY = 'affiliate-status'
const ENDPOINT = '/tripmentor/affiliate/status'

export function fetchAffiliateStatus(currency: string) {
  return axiosInstance
    .get<FetchAffiliateDetailsResponse>(ENDPOINT, {
      params: {
        currency,
      },
    })
    .then((response) => response.data.data)
}

export function useAffiliateStatus(
  currency: Ref<string>,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchAffiliateStatus>>>
) {
  return useQuery({
    queryFn: () => fetchAffiliateStatus(currency.value),
    queryKey: [QUERY_KEY, currency],
    retry: 0,
    ...options,
  })
}
